import fromByteToHex from './fromByteToHex.util';

const fromArrayBufferToHexString = (arrayBuffer) =>
  Array.from(new Uint8Array(arrayBuffer))
    .map(fromByteToHex)
    .join('');

// noinspection JSUnusedGlobalSymbols
export default fromArrayBufferToHexString;
